import React from 'react'

export default class ResetPassword extends React.Component {
  
  constructor(props) {
    super(props)

    this.onGoogleClick = this.onGoogleClick.bind(this)
  }

  componentDidMount() {
    var self = this;

    this.gapiLoadInterval = setInterval(function () {
      if (typeof gapi !== 'undefined') {
        // load the gapi once it's available
        self.loadGAPI();
      }
    }, 100);
  }

  render() {
    return (
      <div>
        <div className="login-provider-button-wrapper">
          <div className="google-login-button-wrapper">
            <button type="button" onClick={this.onGoogleClick} className="loginBtn loginBtn--google google-login-button">{I18n.t('sign_in_with_google')}</button>
          </div>
        </div>
        
        <hr />
      </div>
    );
  }

  /**
   * Change handlers
   */

  onGoogleClick() {
    var self = this;

    self.props.onChangeErrors([])
    
    if (gapi && gapi.auth2 && gapi.auth2.authorize) {
      gapi.auth2.authorize({
        client_id: self.props.google_id,
        cookie_policy: 'single_host_origin',
        scope: 'email profile',
        response_type: 'code'
      }, function(response) {
        if (response && !response.error) {
          response.property_id = self.props.property.id
          jQuery.ajax({
            type: 'POST',
            url: '/auth/google_oauth2/callback',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            },
            data: response,
            success: function(data) {
              //console.log('google sign in success', data);
              if (data && data.success) {
                window.location.href = data.success
              } else {
                self.props.onChangeErrors([I18n.t('google_sign_in_failed')])
              }
              // if (self.props.customerForm === 'signUp' && data && data.id && !data.google_token) {
              //   console.log('sign up, but user already has id, which means they already exist, so they should sign in instead...')
              //   // sign up, but user already has id, which means they already exist, so they should sign in instead
              //   // deleting data.id will make this happen
              //   data = {id: undefined, email: data.email_address}
              // }
              // self.props.onGoogleSignIn(data, self.onCustomerValidate)
            }
          });
        } else {
          // google authentication failed
          //console.log('google sign in failed', response);
        }
      });
    }
  }

  /**
   * Helper functions
   */

   loadGAPI() {
    var self = this;
    gapi.load('auth2', function() {
      // console.log('google api loaded');
      if (self.gapiLoadInterval) {
        clearInterval(self.gapiLoadInterval);
      }
    });
  }

}